export const CDP_EVENTS = {
  SCREENER_OUTPUT_ERROR: 'SCREENER_OUTPUT_ERROR',
  SCREENER_OUTPUT: 'SCREENER_OUTPUT',
  SCREENER_SECOND_QUESTION: 'SCREENER_SECOND_QUESTION',
  SITE_SELECTION_TOGGLE: 'SITE_SELECTION_TOGGLE',
  SITE_SELECTION_TOGGLE_ERROR: 'SITE_SELECTION_TOGGLE_ERROR',
  SITE_SELECTION_SITE_SELECTED: 'SITE_SELECTION_SITE_SELECTED',
  SITE_SELECTION_SITE_SELECTED_ERROR: 'SITE_SELECTION_SITE_SELECTED_ERROR',
  SITE_SELECTION_NO_SITE_CONVENIENT: 'SITE_SELECTION_NO_SITE_CONVENIENT',
  SITE_SELECTION_NO_SITE_CONVENIENT_ERROR: 'SITE_SELECTION_NO_SITE_CONVENIENT_ERROR',
  SITE_SELECTION_NO_SITE_AVAILABLE_MAX_CAP: 'SITE_SELECTION_NO_SITE_AVAILABLE_MAX_CAP',
  SITE_SELECTION_NO_SITE_AVAILABLE: 'SITE_SELECTION_NO_SITE_AVAILABLE',
  SITE_SELECTION_KIELEMENT_POPUP: 'SITE_SELECTION_KIELEMENT_POPUP',
  SITE_SELECTION_LIFELINK_POPUP: 'SITE_SELECTION_LIFELINK_POPUP',
  SITE_SELECTION_LIFELINK_POPUP_CONTINUE: 'SITE_SELECTION_LIFELINK_POPUP_CONTINUE',
  SITE_SELECTION_LIFELINK_POPUP_CANCELLED: 'SITE_SELECTION_LIFELINK_POPUP_CANCELLED',
  CONTACT_FORM_SUBMIT: 'CONTACT_FORM_SUBMIT',
  CONTACT_FORM_ERROR: 'CONTACT_FORM_ERROR',
  HOME_PAGE_LOAD: 'HOME_PAGE_LOAD',
  SUCCESS_PAGE_FAILURE: 'SUCCESS_PAGE_FAILURE',
  SUCCESS_PAGE_LOADED: 'SUCCESS_PAGE_LOADED',
  MY_PROFILE_EMAIL_LINK_CLICK: 'MY_PROFILE_EMAIL_LINK_CLICK',
  UNSUBSCRIBE_CLICK: 'UNSUBSCRIBE_CLICK',
  RESUBSCRIBE_CLICK: 'RESUBSCRIBE_CLICK',
  UPDATE_EMAIL: 'EMAIL_UPDATE',
  ADD_COMMUNITY: 'ADD_COMMUNITY',
  ADD_COMMUNITY_CR: 'ADD_COMMUNITY_CR_REGISTRATION',
  ADD_COMMUNITY_CAREGIVER: 'ADD_COMMUNITY_CAREGIVER',
  ADD_COMMUNITY_ADULT: 'ADD_COMMUNITY_ADULT',
  ADD_COMMUNITY_MINOR: 'ADD_COMMUNITY_MINOR',
  UPDATE_COMMUNITY: 'UPDATE_COMMUNITY_MY_PROFILE',
  UPDATE_COMMUNITY_EMAIL: 'UPDATE_COMMUNITY_EMAIL',
  REMOVE_COMMUNITY: 'REMOVE_COMMUNITY',
  IDLE_SESSION_TIMEOUT: 'IDLE_SESSION_TIMEOUT',
  LOGOUT: 'LOGOUT',
  CDP_API_CONTACTINFO_FAILURE: 'CDP_API_CONTACTINFO_FAILURE',
  CDP_API_CONTACTINFO_SUCCESS: 'CDP_API_CONTACTINFO_SUCCESS',
  API_FAILURE: 'API_FAILURE',
  CDP_API_FETCHPROFILE_SUCCESS: 'CDP_API_FETCHPROFILE_SUCCESS',
  CDP_API_FETCHPROFILE_FAILURE: 'CDP_API_FETCHPROFILE_FAILURE',
  CONTACTFORM_EXPERIENCE_SUCCESS: 'CONTACTFORM_EXPERIENCE_SUCCESS',
  CONTACTFORM_EXPERIENCE_FAILURE: 'CONTACTFORM_EXPERIENCE_FAILURE',
  BASE_PROFILE_UPDATED: 'BASE_PROFILE_UPDATED',
  SCREENER_CTA_LINK_CLICKED: 'SCREENER_CTA_LINK_CLICKED',
  CONTACTINFO_NEXT_BUTTON_CLICK: 'CONTACTINFO_NEXT_BUTTON_CLICK',
  CONTACTINFO_BACK_BUTTON_CLICK: 'CONTACTINFO_BACK_BUTTON_CLICK',
  CONTACTINFO_NOTNOW_BUTTON_CLICK: 'CONTACTINFO_NOTNOW_BUTTON_CLICK',
  CONTACTINFO_VALIDATION_FAILURE: 'CONTACTINFO_VALIDATION_FAILURE',
  PERSONALIZED_FEATURED_LINK_CLICK: 'PERSONALIZED_FEATURED_LINK_CLICK',
  STUDYQUESTIONNAIRE_LINK_CLICK: 'STUDYQUESTIONNAIRE_LINK_CLICK',
  FEATURED_LINK_CLICK: 'FEATURED_LINK_CLICK',
  DAP_API_ADD_UCPM_DETAILS: 'DAP_API_ADD_UCPM_DETAILS',
  FOV_STATUS: 'FOV_STATUS',
  SCREENER_STARTED: 'SCREENER_STARTED',
  SCREENER_COMPLETED: 'SCREENER_COMPLETED',
};

export const CONTACT_INFO_URLS = {
  ADULT: '/adult',
  MINOR: '/minor',
  CAREGIVER: '/caregiver',
};

export const ZIPCODE_FIELDS = {
  ADULT_PATIENT_ZIPCODE: 'Zipcode',
  MINOR_DELEGATE_ZIPCODE: 'ZipCode',
  CAREGIVER_PATIENT_ZIPCODE: 'ParticipantZipcode',
  CAREGIVER_DELEGATE_ZIPCODE: 'CaregiverZipCode',
};

export const JOURNEY_STEP = {
  CONTACT_INFO: 'contact-info',
  SCREENER: 'screener',
  SITESELECTION: 'site-selection',
};

export const JOURNEY_STATUS = {
  PARTIAL: 'Partial',
  COMPLETED: 'Complete',
  PARTIAL_EXTERNAL_SCREENER: 'Partial-External-Screener',
};

export const DEFAULT_SCREENER_TYPE = 'Alchemer';
export const ARETI_DEFAULT_SCREENER_TYPE = 'AretiHealth';
export const MEGASCREENER_DEFAULT_SCREENER_TYPE = 'MegaScreener';

export const SCREENER_STATUS = {
  QUALIFIED: 'qualified',
  DISQUALIFIED: 'disqualified',
};
export const NSC_STATUS = {
  NOSITECONVENIENT: 'No-site-convenient',
  SITENOTCONVENIENT: 'Site-not-convenient',
};

export const JOURNEYS = {
  JOURNEY_01: 'Screener-SiteSelection-ContactInfo',
  JOURNEY_02: 'Screener-ContactInfo-SiteSelection',
  JOURNEY_03: 'ContactInfo-Screener-SiteSelection',
} as const;

export const JOURNEYS_ID_MAPPER = {
  '{C4C532DC-F337-4A9B-B5F7-D86700C899EA}': 'Screener-SiteSelection-ContactInfo',
  '{1E2A09A7-AE87-4005-BF43-1C33D9D488B0}': 'Screener-ContactInfo-SiteSelection',
  '{BB766A4A-E89F-4508-8B0A-3B19A858A1D5}': 'ContactInfo-Screener-SiteSelection',
} as const;

export const DEFAULT_ZIPCODE_ERROR_MESSAGE = { value: 'Please enter a valid zipcode' };
export const DEFAULT_ZIPCODE_REQUIRED_MESSAGE = { value: 'Please enter a zipcode' };
export const DEFAULT_ZIPCODE_INVALID_MESSAGE = { value: 'Invalid zipcode format' };
export const DEFAULT_SEARCH_BUTTON_TEXT = { value: 'Search' };

export enum CAROUSEL_VARIATION {
  VARIATION1 = 'Variation1',
  VARIATION2 = 'Variation2',
  VARIATION3 = 'Variation3',
  VARIATION4 = 'Variation4',
}

export enum CAROUSEL_TYPE {
  IMAGE = 'Image',
  SITECORE = 'Sitecore',
  YOUTUBE = 'Youtube',
  VIMEO = 'Vimeo',
}
export const VIEW_ALL_OPTION_VALUE = 'viewall';

export const STUDY_LOCATION_VARIATIONS = {
  VARIATION_ONE: 'Variation1',
  VARIATION_TWO: 'Variation2',
  VARIATION_THREE: 'Variation3',
};

export enum PATIENT_TYPE {
  ADULT = '{ED808045-0230-4744-932C-881A018120FC}',
  CAREGIVER = '{4D70D876-4C34-4EC3-A64C-4250DB9A1042}',
  MINOR = '{D552592D-2140-48BE-9D6E-1CDEEA1A3981}',
}
export const EXPLORE_PROFILE = 'Explore Profile';
export const EMAIL_ADDRESS_RESEND = 'EmailAddressResend';
export const PROFILE_VERIFY_TOKEN_KEY = 'myProfileVerificationToken';
export const PATIENT_TYPE_ADULT = 'Potential Participant';
export enum EMAIL_TEMPLATES {
  REGISTRATION_WELCOME = 'Registration-Welcome',
  MANAGE_PROFILE = 'Manage-Profile',
  HCP_REGISTRATION = 'HCP_Registration',
}

export enum EMAIL_TEMPLATE {
  REGISTRATION_WELCOME = 'Registration-Welcome',
  MANAGE_PROFILE = 'Manage-Profile',
  HCP_REGISTRATION = 'HCP_Registration',
}

export enum TagType {
  ENROLLING = 'enrolling',
  NOT_YET_ENROLLING = 'notYetEnrolling',
  GOOD_MATCH = 'goodMatch',
  VIRTUAL = 'virtual',
}

export const EMAIL_SOURCE = 'CR';
export const SITE_SOURCE = 'CR';

// ─── FOV Scheduling ───────────────────────────────────────────────────────────

export const MOCK_FOV_SCHEDULING_URL = '/FOVDUMMY/fov-scheduling';

export const MOCK_SUCCESS_URL = '/en/siteselectionsuccess';

export const FOV_SOURCE = 'DAP';
export const FOV_INTEGRATION_SOURCE = 'RH';

export const FOV_APPOINTMENT_STATUS = {
  SITE_DIRECTED_SCHEDULING: 'siteDirectedSchedule',
  INITIATED: 'Initiated',
  NO_SLOTS_AVAILABLE_FOR_SUBJECT: 'noSlotsAvailableForSubject',
  NO_SLOTS_WORKED_FOR_SUBJECT: 'noSlotsWorkedForSubject',
  REQUESTED: 'requested',
  NOT_INITIATED: 'NotInitiated',
} as const;

export const FOV_BOOKING_STATUS = {
  BOOKED: 'Booked',
} as const;
